import { getLatestArrearsHalfRange } from '@koda/koda-utils/date';
import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, type BusinessInformation } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

export const HANDBALL_CONTENT_PATH = 'licenses.steps.businessInformation.forms.handball';

export const handballSchema = BasicBusinessInformationSchema.extend({
  spectators: z
    .number({
      required_error: `${HANDBALL_CONTENT_PATH}.spectators.validation.required`,
    })
    .int({ message: `${HANDBALL_CONTENT_PATH}.spectators.validation.required` })
    .min(1, { message: `${HANDBALL_CONTENT_PATH}.spectators.validation.required` }),
});

export type HandballForm = z.infer<typeof handballSchema>;

export const createHandballDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.Handball,
});

export const toPayloadHandball = (form: HandballForm, wareNumber: number): GeneralPayload => {
  const { start, end } = getLatestArrearsHalfRange();
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs(start).format('YYYY-MM-DD'),
    musicEndDate: dayjs(end).format('YYYY-MM-DD'),
    quantity: form.spectators ?? 0,
  };
};
